/**
 * MADEMOISELLE MARCELLE \u2014 CART DRAWER
 * Version maison (remplace UpCart)
 *
 * Fonctionnalit\u00e9s :
 * - Cart drawer AJAX (open/close/update)
 * - Barre de progression livraison (Point Relais 69\u20ac / Domicile 89\u20ac)
 * - Upsell : API Reco Shopify avec fallback Best-sellers
 * - Carousel upsell (navigation prev/next)
 * - Ajout upsell en 1 clic
 * - Quantit\u00e9 +/- avec debounce
 * - Suppression article
 * - Add-on : Traitement prioritaire (activ\u00e9 par d\u00e9faut)
 */

(function () {
  'use strict';

  // ============================================================
  // CONFIG \u2014 \u00e0 adapter si besoin
  // ============================================================
  const CONFIG = {
    RELAY_THRESHOLD: 6900,       // centimes \u2014 seuil livraison point relais (69\u20ac)
    HOME_THRESHOLD: 14900,        // centimes \u2014 seuil livraison domicile (89\u20ac)
    BESTSELLER_COLLECTION: 'meilleures-ventes', // handle de ta collection
    UPSELL_LIMIT: 6,             // nb max de produits upsell \u00e0 charger
    DEBOUNCE_DELAY: 400,         // ms avant d'envoyer la mise \u00e0 jour quantit\u00e9
    ADDON_VARIANT_ID: 50857337585993, // Traitement prioritaire \u2014 variant ID
  };

  // ============================================================
  // STATE
  // ============================================================
  let cart = null;
  let upsellProducts = [];
  let upsellIndex = 0;
  let isUpdating = false;
  let qtyTimers = {};
  let addonDeclined = false; // true si le client a volontairement retir\u00e9 l'addon

  let _mmFetchCount = 0;   // compteur d'appels fetch internes (anti-boucle interceptor)
  let selectedCountryCode = 'FR';

  // ============================================================
  // SELECTORS
  // ============================================================
  const drawer = () => document.getElementById('mm-cart-drawer');
  const overlay = () => document.getElementById('mm-cart-overlay');
  const content = () => document.getElementById('mm-cart-content');

  // ============================================================
  // OPEN / CLOSE
  // ============================================================
  function openCart() {
    drawer()?.classList.add('is-open');
    overlay()?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function closeCart() {
    drawer()?.classList.remove('is-open');
    overlay()?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ============================================================
  // FETCH CART
  // ============================================================
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    if (!res.ok) throw new Error('Erreur chargement panier');
    return res.json();
  }

  // ============================================================
  // FETCH UPSELL PRODUCTS
  // Strategy: API Reco Shopify d'abord, fallback best-sellers
  // ============================================================
  async function fetchUpsellProducts(cartItems) {
    // On essaie avec le premier produit du panier (hors addon)
    const firstItem = cartItems?.find(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID);

    if (firstItem?.product_id) {
      try {
        const res = await fetch(
          `/recommendations/products.json?product_id=${firstItem.product_id}&limit=${CONFIG.UPSELL_LIMIT}`
        );
        const data = await res.json();

        // Filtrer les produits d\u00e9j\u00e0 dans le panier
        const cartProductIds = cartItems.map(i => i.product_id);
        const filtered = data.products.filter(p => !cartProductIds.includes(p.id) && p.available);

        if (filtered.length >= 2) {
          return filtered;
        }
      } catch (e) {
        // Silently fallback
      }
    }

    // Fallback : collection best-sellers
    try {
      const res = await fetch(
        `/collections/${CONFIG.BESTSELLER_COLLECTION}/products.json?limit=${CONFIG.UPSELL_LIMIT}&sort_by=best-selling`
      );
      const data = await res.json();
      const cartProductIds = (cartItems || []).map(i => i.product_id);
      return data.products.filter(p => !cartProductIds.includes(p.id));
    } catch (e) {
      return [];
    }
  }

  // ============================================================
  // ADD-ON : Traitement prioritaire
  // ============================================================
  function isAddonInCart() {
    return cart?.items?.some(i => i.variant_id === CONFIG.ADDON_VARIANT_ID) ?? false;
  }

  async function autoAddAddon() {
    if (addonDeclined) return;
    if (isAddonInCart()) return;
    if (!cart || cart.item_count === 0) return;
    // Compter les vrais articles (hors addon)
    const realItems = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID);
    if (realItems.length === 0) return;

    try {
      _mmFetchCount++;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: CONFIG.ADDON_VARIANT_ID, quantity: 1 }),
      });
      cart = await fetchCart();
    } catch (e) {
      // Silently fail \u2014 l'addon reste optionnel
    } finally {
      _mmFetchCount--;
    }
  }

  async function toggleAddon(activate) {
    const label = document.querySelector('.mm-addon-toggle');
    if (label) label.classList.add('is-loading');

    try {
      if (activate) {
        addonDeclined = false;
        _mmFetchCount++;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: CONFIG.ADDON_VARIANT_ID, quantity: 1 }),
        });
        _mmFetchCount--;
      } else {
        addonDeclined = true;
        // Trouver la cl\u00e9 de l'addon dans le panier
        const addonItem = cart?.items?.find(i => i.variant_id === CONFIG.ADDON_VARIANT_ID);
        if (addonItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addonItem.key, quantity: 0 }),
          });
        }
      }

      cart = await fetchCart();
      renderCheckoutBtn();
      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: cart }));
    } catch (e) {
      // Rollback visuel
      const input = document.getElementById('mm-addon-toggle-input');
      if (input) input.checked = !activate;
    } finally {
      if (label) label.classList.remove('is-loading');
    }
  }




  function bindAddonToggle() {
    const input = document.getElementById('mm-addon-toggle-input');
    if (!input) return;

    // Sync \u00e9tat visuel avec panier
    input.checked = isAddonInCart();

    input.addEventListener('change', (e) => {
      toggleAddon(e.target.checked);
    });
  }

  // ============================================================
  // RENDER
  // ============================================================
  async function fetchAndRender() {
    const c = content();
    if (!c) return;

    // Loader
    c.innerHTML = `<div class="mm-cart-loading"><div class="mm-spinner"></div></div>`;

    try {
      cart = await fetchCart();

      if (cart.item_count === 0 || cart.items.every(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)) {
        // Panier vide (ou seulement l'addon) \u2014 retirer l'addon si pr\u00e9sent
        if (isAddonInCart()) {
          const addonItem = cart.items.find(i => i.variant_id === CONFIG.ADDON_VARIANT_ID);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: addonItem.key, quantity: 0 }),
          });
          cart = await fetchCart();
        }
        await renderEmpty();
      } else {
        // Auto-ajouter l'addon si pas d\u00e9clin\u00e9
        await autoAddAddon();
        if (isAddonInCart()) cart = await fetchCart();

        upsellProducts = await fetchUpsellProducts(cart.items);
        upsellIndex = 0;
        renderFilled();
      }

      // Mettre \u00e0 jour le compteur header apr\u00e8s chaque render
      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: cart }));
    } catch (e) {
      console.error('[MM] fetchAndRender error:', e);
      c.innerHTML = `<p style="padding:24px;text-align:center;color:#999;">Erreur de chargement. Veuillez r\u00e9essayer.</p>`;
    }
  }

  async function renderEmpty() {
    const tpl = document.getElementById('mm-cart-empty-template');
    content().innerHTML = tpl ? tpl.innerHTML : '';

    // Charger les best-sellers pour l'\u00e9tat vide
    const populaires = await fetchUpsellProducts([]);
    upsellProducts = populaires;
    upsellIndex = 0;
    renderUpsellTrack('mm-upsell-empty-track');
  }

  function renderFilled() {
    // Annuler les timers qty p\u00e9rim\u00e9s avant re-render
    Object.keys(qtyTimers).forEach(k => clearTimeout(qtyTimers[k]));
    qtyTimers = {};
    try {
      const tpl = document.getElementById('mm-cart-filled-template');
      content().innerHTML = tpl ? tpl.innerHTML : '';

      renderShippingBar();
      renderItems();
      renderUpsellTrack('mm-upsell-track');
      bindAddonToggle();
      renderCheckoutBtn();
      bindItemEvents();
      bindUpsellNav();
    } catch (e) {
      console.error('[MM] renderFilled error:', e);
      throw e;
    }
  }

  // ---- Barre de progression ----
  function renderShippingBar() {
    // Calculer le total HORS addon
    const addonTotal = cart.items
      .filter(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)
      .reduce((s, i) => s + i.final_line_price, 0);
    const total = cart.total_price - addonTotal;

    const msgEl = document.getElementById('mm-shipping-msg');
    const relayMilestone = document.getElementById('mm-milestone-relay');
    const homeMilestone = document.getElementById('mm-milestone-home');

    // Cr\u00e9er la barre si elle n'existe pas encore
    const shippingBar = document.getElementById('mm-shipping-bar');
    if (shippingBar && !shippingBar.querySelector('.mm-shipping-progress-bar')) {
      const progressBar = document.createElement('div');
      progressBar.className = 'mm-shipping-progress-bar';
      const fill = document.createElement('div');
      fill.className = 'mm-shipping-fill';
      fill.id = 'mm-shipping-fill';
      progressBar.appendChild(fill);
      shippingBar.querySelector('.mm-shipping-track').insertBefore(progressBar, shippingBar.querySelector('.mm-shipping-milestones'));
    }

    const fillEl = document.getElementById('mm-shipping-fill');

    // \u00c9chelle lin\u00e9aire : barre = 0 \u2192 HOME_THRESHOLD
    // Relay positionn\u00e9 \u00e0 RELAY/HOME = 69/89 \u2248 77,5 % de la barre
    const relayPct = (CONFIG.RELAY_THRESHOLD / CONFIG.HOME_THRESHOLD) * 100;
    if (relayMilestone) relayMilestone.style.left = relayPct + '%';

    const linearPct = (total / CONFIG.HOME_THRESHOLD) * 100;

    if (total >= CONFIG.HOME_THRESHOLD) {
      if (msgEl) msgEl.textContent = '\ud83c\udf89 Livraison \u00e0 domicile offerte !';
      if (fillEl) fillEl.style.width = '100%';
      if (relayMilestone) relayMilestone.classList.add('reached');
      if (homeMilestone) homeMilestone.classList.add('reached');
    } else if (total >= CONFIG.RELAY_THRESHOLD) {
      const remaining = ((CONFIG.HOME_THRESHOLD - total) / 100).toFixed(2).replace('.', ',');
      if (msgEl) msgEl.innerHTML = `Plus que <strong>${remaining} \u20ac</strong> pour obtenir la livraison \u00e0 domicile gratuite.`;
      if (fillEl) fillEl.style.width = `${Math.min(linearPct, 99)}%`;
      if (relayMilestone) relayMilestone.classList.add('reached');
      if (homeMilestone) homeMilestone.classList.remove('reached');
    } else {
      const remaining = ((CONFIG.RELAY_THRESHOLD - total) / 100).toFixed(2).replace('.', ',');
      if (msgEl) msgEl.innerHTML = `Plus que <strong>${remaining} \u20ac</strong> pour obtenir la livraison en point relais gratuite.`;
      if (fillEl) fillEl.style.width = `${Math.min(Math.max(linearPct, 3), relayPct - 0.5)}%`;
      if (relayMilestone) relayMilestone.classList.remove('reached');
      if (homeMilestone) homeMilestone.classList.remove('reached');
    }
  }

  // ---- Articles ----
  function renderItems() {
    const container = document.getElementById('mm-cart-items');
    if (!container) return;

    // Associer chaque item \u00e0 son num\u00e9ro de ligne Shopify (1-index\u00e9 sur cart.items complet)
    // puis filtrer les articles visibles (hors addon, quantit\u00e9 > 0)
    const visibleItems = cart.items
      .map((item, idx) => ({ item, line: idx + 1 }))
      .filter(({ item }) => item.variant_id !== CONFIG.ADDON_VARIANT_ID && item.quantity > 0);

    container.innerHTML = visibleItems.map(({ item, line }) => {
      const variantParts = [];
      if (item.variant_title && item.variant_title !== 'Default Title') {
        item.variant_title.split(' / ').forEach(v => variantParts.push(v));
      }
      const variantHTML = variantParts.length
        ? variantParts.map(v => `<span class="mm-item-variant">${escHtml(v)}</span>`).join('')
        : '';

      const price = formatMoney(item.final_line_price);
      const img = item.image
        ? item.image.replace(/(\.[^.]+)$/, '_120x$1')
        : '';

      return `
        <div class="mm-cart-item" data-line="${line}">
          ${img
            ? `<img class="mm-item-img" src="${escHtml(img)}" alt="${escHtml(item.product_title)}" loading="eager" width="72" height="90">`
            : `<div class="mm-item-img"></div>`
          }
          <div class="mm-item-info">
            <p class="mm-item-name">${escHtml(item.product_title)}</p>
            ${variantHTML ? `<div class="mm-item-variants">${variantHTML}</div>` : ''}
            <div class="mm-item-qty">
              <button class="mm-qty-btn mm-qty-minus" data-line="${line}" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Diminuer">\u2212</button>
              <span class="mm-qty-value">${item.quantity}</span>
              <button class="mm-qty-btn mm-qty-plus" data-line="${line}" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Augmenter">+</button>
            </div>
          </div>
          <div class="mm-item-right">
            <button class="mm-item-remove" data-line="${line}" data-key="${item.key}" aria-label="Supprimer">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4h10M5 4V2.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V4M5.5 6.5v4M8.5 6.5v4M3 4l.7 7.5a.5.5 0 00.5.5h5.6a.5.5 0 00.5-.5L11 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <span class="mm-item-price">${price}</span>
          </div>
        </div>
      `;
    }).join('');
  }

  // ---- Upsell carousel ----
  function renderUpsellTrack(trackId) {
    const track = document.getElementById(trackId);
    if (!track || !upsellProducts.length) {
      const section = track?.closest('.mm-upsell');
      if (section) section.style.display = 'none';
      return;
    }

    track.innerHTML = upsellProducts.map((product, i) => {
      const variant = product.variants?.[0];
      if (!variant) return '';

      // Image : URL en string ou objet selon l'API
      const imgRaw = typeof product.images?.[0] === 'string'
        ? product.images[0]
        : (product.images?.[0]?.src || '');
      const img = imgRaw ? imgRaw.replace(/(\.[^.]+)$/, '_400x$1') : '';

      // Prix : l'API produits renvoie un float string ("29.90"), l'API cart renvoie des centimes.
      // On normalise : si c'est une string ou un float < 10000, on multiplie par 100.
      const rawPrice = variant.price;
      const priceInCents = typeof rawPrice === 'string'
        ? Math.round(parseFloat(rawPrice) * 100)
        : (rawPrice < 500 ? Math.round(rawPrice * 100) : rawPrice);
      const price = formatMoney(priceInCents);

      let variantSelect = '';
      if (product.variants.length > 1) {
        variantSelect = `<select class="mm-upsell-select" data-product="${product.id}">
          ${product.variants.map(v => { const avail = v.available !== false; return `<option value="${v.id}"${avail ? '' : ' disabled'}>` + escHtml(v.title) + (avail ? '' : ' (\u00e9puis\u00e9)') + '</option>'; }).join('')}
        </select>`;
      } else {
        variantSelect = `<input type="hidden" class="mm-upsell-select" data-product="${product.id}" value="${variant.id}">`;
      }

      return `
        <div class="mm-upsell-card" data-upsell-idx="${i}">
          <a class="mm-upsell-img-wrap" href="${escHtml(product.url || '#')}" tabindex="-1" aria-hidden="true">
            ${img
              ? `<img class="mm-upsell-img" src="${escHtml(img)}" alt="${escHtml(product.title)}" loading="lazy">`
              : `<div class="mm-upsell-img mm-upsell-img--placeholder"></div>`
            }
          </a>
          <div class="mm-upsell-info">
            <p class="mm-upsell-name">${escHtml(product.title)}</p>
            <p class="mm-upsell-price">${price}</p>
            <div class="mm-upsell-bottom">
              ${variantSelect}
              <button class="mm-upsell-add" data-product="${product.id}">Ajouter</button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    updateUpsellNav(trackId);
    bindUpsellAdd(track);
  }

  function updateUpsellNav(trackId) {
    const prevBtn = document.getElementById('mm-upsell-prev');
    const nextBtn = document.getElementById('mm-upsell-next');
    const maxIndex = Math.max(0, upsellProducts.length - 1);
    if (prevBtn) {
      prevBtn.disabled = upsellIndex === 0;
      prevBtn.style.opacity = upsellIndex === 0 ? '0.25' : '1';
    }
    if (nextBtn) {
      nextBtn.disabled = upsellIndex >= maxIndex;
      nextBtn.style.opacity = upsellIndex >= maxIndex ? '0.25' : '1';
    }
  }

  function showUpsellCard(trackId, newIndex) {
    const track = document.getElementById(trackId);
    if (!track) return;
    const cards = track.querySelectorAll('.mm-upsell-card');
    if (!cards.length) return;
    const gap = 10;
    const cardW = cards[0].offsetWidth + gap;
    track.scrollTo({ left: newIndex * cardW, behavior: 'smooth' });
    upsellIndex = newIndex;
    updateUpsellNav(trackId);
  }

  function bindUpsellNav() {
    const prevBtn = document.getElementById('mm-upsell-prev');
    const nextBtn = document.getElementById('mm-upsell-next');
    const track = document.getElementById('mm-upsell-track');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (upsellIndex > 0) showUpsellCard('mm-upsell-track', upsellIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (upsellIndex < upsellProducts.length - 1) showUpsellCard('mm-upsell-track', upsellIndex + 1);
      });
    }

    // Sync upsellIndex lors du swipe mobile
    if (track) {
      track.addEventListener('scroll', () => {
        const cards = track.querySelectorAll('.mm-upsell-card');
        if (!cards.length) return;
        const gap = 10;
        const cardW = cards[0].offsetWidth + gap;
        if (cardW > 0) {
          upsellIndex = Math.round(track.scrollLeft / cardW);
          updateUpsellNav('mm-upsell-track');
        }
      }, { passive: true });
    }
  }

  function bindUpsellAdd(track) {
    if (!track) return;

    // Image update on variant change
    track.querySelectorAll('.mm-upsell-select').forEach(select => {
      if (select.tagName !== 'SELECT') return;
      select.addEventListener('change', () => {
        const card = select.closest('.mm-upsell-card');
        const productId = parseInt(select.dataset.product);
        const variantId = parseInt(select.value);
        const product = upsellProducts.find(p => p.id === productId);
        if (!product) return;
        const variant = product.variants.find(v => v.id === variantId);
        if (!variant) return;
        const imgEl = card?.querySelector('.mm-upsell-img');
        if (imgEl && imgEl.tagName === 'IMG') {
          // featured_image peut \u00eatre une string ou un objet selon l'API
          const fi = variant.featured_image;
          const rawSrc = (typeof fi === 'string' ? fi : fi?.src)
            || (typeof product.images?.[0] === 'string' ? product.images[0] : product.images?.[0]?.src);
          if (rawSrc) imgEl.src = rawSrc.replace(/(\.[^.]+)$/, '_120x$1');
        }
        const priceEl = card?.querySelector('.mm-upsell-price');
        if (priceEl) {
          const rp = variant.price;
          const cents = typeof rp === 'string'
            ? Math.round(parseFloat(rp) * 100)
            : (rp < 500 ? Math.round(rp * 100) : rp);
          priceEl.textContent = formatMoney(cents);
        }
      });
    });

    track.querySelectorAll('.mm-upsell-add').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const card = e.target.closest('.mm-upsell-card');
        const select = card?.querySelector('.mm-upsell-select');
        const variantId = select?.value;
        if (!variantId) return;

        if (isUpdating) return;
        isUpdating = true;
        btn.classList.add('is-loading');
        btn.textContent = '...';

        // Pr\u00e9charger l'image d\u00e8s le clic, avant le re-render
        try {
          const productId = parseInt(select.dataset.product);
          const product = upsellProducts.find(p => p.id === productId);
          if (product) {
            const fi = product.variants.find(v => v.id === parseInt(variantId))?.featured_image;
            const rawSrc = (typeof fi === 'string' ? fi : fi?.src)
              || (typeof product.images?.[0] === 'string' ? product.images[0] : product.images?.[0]?.src);
            if (rawSrc) {
              const preloadImg = new Image();
              preloadImg.src = rawSrc.replace(/(\.[^.]+)$/, '_120x$1');
            }
          }
        } catch (_) {}

        try {
          await addToCart(variantId, 1);
          cart = await fetchCart();
          upsellProducts = await fetchUpsellProducts(cart.items);
          upsellIndex = 0;
          renderFilled();
        } catch (e) {
          btn.textContent = 'Erreur';
        } finally {
          btn.classList.remove('is-loading');
          isUpdating = false;
        }
      });
    });
  }

  // ---- Ligne livraison dynamique (au-dessus du bouton Finaliser) ----
  function renderShippingLine() {
    const footer = document.querySelector('.mm-footer');
    if (!footer) return;

    let el = footer.querySelector('.mm-shipping-line');
    if (!el) {
      el = document.createElement('div');
      el.className = 'mm-shipping-line';
      const checkoutBtn = footer.querySelector('.mm-checkout-btn, [href*="/checkout"]');
      if (checkoutBtn) footer.insertBefore(el, checkoutBtn);
      else footer.appendChild(el);
    }

    const addonTotal = (cart.items || [])
      .filter(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)
      .reduce((s, i) => s + i.final_line_price, 0);
    const total = cart.total_price - addonTotal;

    if (total >= CONFIG.HOME_THRESHOLD) {
      el.innerHTML = `<span class="mm-sl-paid">Frais de livraison : <strong style="color:#16a34a;font-weight:700;">GRATUIT</strong> (point relais ou domicile)</span>`;
    } else if (total >= CONFIG.RELAY_THRESHOLD) {
      el.innerHTML = `<span class="mm-sl-paid">Frais de livraison : <strong style="color:#16a34a;font-weight:700;">GRATUIT</strong> (en point relais)</span>`;
    } else {
      el.innerHTML = `<span class="mm-sl-paid">Frais de livraison : 4,99 \u20ac <span class="mm-sl-sub">(offert d\u00e8s 69 \u20ac)</span></span>`;
    }
  }

  // ---- S\u00c3\u00a9lecteur de pays livraison ----
  // ---- S\u00e9lecteur de pays livraison ----
  // Structure home : paliers tri\u00e9s du plus \u00e9lev\u00e9 au plus bas (min en centimes)
  const COUNTRY_SHIPPING = [
    { code: 'FR',     label: 'France',    relay: null, home: null },
    { code: 'BE',     label: 'Belgique',   relay: 499,  home: [{ min: 14900, price: 0 }, { min: 0, price: 899 }] },
    { code: 'LU',     label: 'Luxembourg', relay: 499,  home: [{ min: 14900, price: 0 }, { min: 0, price: 899 }] },
    { code: 'NL',     label: 'Pays-Bas',   relay: 499,  home: [{ min: 14900, price: 0 }, { min: 0, price: 1099 }] },
    { code: 'ES',     label: 'Espagne',    relay: 599,  home: [{ min: 0, price: 1299 }] },
    { code: 'CH',     label: 'Suisse',     relay: null, home: [{ min: 14900, price: 0 }, { min: 10000, price: 749 }, { min: 0, price: 1499 }] },
    { code: 'DOMTOM', label: 'DOM-TOM',          relay: null, home: [{ min: 14900, price: 0 }, { min: 10000, price: 649 }, { min: 0, price: 1299 }] },
  ];

  function _csHomeTier(country, total) {
    if (!country.home || !country.home.length) return null;
    return country.home.find(t => total >= t.min) || country.home[country.home.length - 1];
  }

  function _csFmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function _csShippingHtml(country, total) {
    if (!country || country.code === 'FR') return null;
    const tier      = _csHomeTier(country, total);
    const homePrice = tier ? tier.price : null;
    const freeTier  = country.home ? country.home.find(t => t.price === 0) : null;

    if (country.relay !== null) {
      const relayStr = _csFmt(country.relay);
      if (total >= 6900) {
        return '<span class="mm-sl-paid">Frais de livraison : <strong style="color:#16a34a;font-weight:700;">GRATUIT</strong> (en point relais)</span>';
      }
      return '<span class="mm-sl-paid">Frais de livraison : ' + relayStr + ' <span class="mm-sl-sub">(offert d\u00e8s 69 \u20ac)</span></span>';
    } else {
      if (homePrice === 0) {
        return '<span class="mm-sl-paid">Frais de livraison : <strong style="color:#16a34a;font-weight:700;">GRATUIT</strong></span>';
      }
      const homeStr = _csFmt(homePrice);
      if (country.home && country.home.length > 1) {
        const upcoming = country.home.filter(t => t.min > total).sort((a, b) => a.min - b.min);
        if (upcoming.length >= 2) {
          const nextPaid = upcoming[0];
          const freeTier = upcoming.find(t => t.price === 0);
          const nextStr  = _csFmt(nextPaid.price);
          const nextAt   = Math.round(nextPaid.min / 100);
          const freeAt   = freeTier ? Math.round(freeTier.min / 100) : null;
          if (freeAt) {
            return '<span class="mm-sl-amount">Livraison\u00a0: ' + homeStr + '</span> <span class="mm-sl-sub">(' + nextStr + ' d\u00e8s\u00a0' + nextAt + '\u00a0\u20ac, offerte d\u00e8s\u00a0' + freeAt + '\u00a0\u20ac)</span>';
          }
          return '<span class="mm-sl-amount">Livraison\u00a0: ' + homeStr + '</span> <span class="mm-sl-sub">(' + nextStr + ' d\u00e8s\u00a0' + nextAt + '\u00a0\u20ac)</span>';
        } else if (upcoming.length === 1) {
          const nextTier = upcoming[0];
          const nextAt   = Math.round(nextTier.min / 100);
          if (nextTier.price === 0) {
            return '<span class="mm-sl-amount">Livraison\u00a0: ' + homeStr + '</span> <span class="mm-sl-sub">(offerte d\u00e8s\u00a0' + nextAt + '\u00a0\u20ac)</span>';
          }
          const nextLabel = _csFmt(nextTier.price);
          return '<span class="mm-sl-amount">Livraison\u00a0: ' + homeStr + '</span> <span class="mm-sl-sub">(' + nextLabel + ' d\u00e8s\u00a0' + nextAt + '\u00a0\u20ac)</span>';
        }
      }
      return '<span class="mm-sl-amount">Livraison\u00a0: ' + homeStr + '</span>';
    }
  }

  function _csUpdateShippingLine(countryCode, total) {
    const footer = document.querySelector('.mm-footer');
    if (!footer) return;
    const shippingLine = footer.querySelector('.mm-shipping-line');
    if (!shippingLine) return;
    if (countryCode === 'FR') {
      renderShippingLine();
    } else {
      const country = COUNTRY_SHIPPING.find(c => c.code === countryCode);
      const html = _csShippingHtml(country, total);
      if (html) shippingLine.innerHTML = html;
    }
  }

  function renderCountrySelector() {
    const footer = document.querySelector('.mm-footer');
    if (!footer) return;

    const addonTotal = (cart.items || [])
      .filter(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)
      .reduce((s, i) => s + i.final_line_price, 0);
    const total = cart.total_price - addonTotal;

    const existing = footer.querySelector('.mm-country-selector');
    if (existing) {
      const sel = existing.querySelector('select');
      if (sel) sel.value = selectedCountryCode;
      _csUpdateShippingLine(selectedCountryCode, total);
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'mm-country-selector';

    const options = COUNTRY_SHIPPING.map(c =>
      '<option value="' + c.code + '" ' + (c.code === 'FR' ? 'selected' : '') + '>' + c.label + '</option>'
    ).join('');

    wrapper.innerHTML = '\n      <svg class="mm-country-selector__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">\n        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>\n        <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>\n      </svg>\n      <select class="mm-country-selector__select" aria-label="Pays de livraison">\n        ' + options + '\n      </select>\n    ';

    const shippingLine = footer.querySelector('.mm-shipping-line');
    if (shippingLine) footer.insertBefore(wrapper, shippingLine);
    else { const checkoutBtn = footer.querySelector('.mm-checkout-btn, [href*="/checkout"]'); if (checkoutBtn) footer.insertBefore(wrapper, checkoutBtn); else footer.appendChild(wrapper); }

    wrapper.querySelector('select').value = selectedCountryCode;
    _csUpdateShippingLine(selectedCountryCode, total);

    wrapper.querySelector('select').value = selectedCountryCode;
    _csUpdateShippingLine(selectedCountryCode, total);

    wrapper.querySelector('select').addEventListener('change', function () {
      selectedCountryCode = this.value;
      const addonT = (cart.items || [])
        .filter(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)
        .reduce((s, i) => s + i.final_line_price, 0);
      _csUpdateShippingLine(selectedCountryCode, cart.total_price - addonT);
    });
  }


  // ---- Bouton checkout ----
  function renderCheckoutBtn() {
    const totalEl = document.getElementById('mm-checkout-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    renderShippingLine();
    renderCountrySelector();
  }

  // ============================================================
  // EVENTS \u2014 Items (qty, remove)
  // ============================================================
  function bindItemEvents() {
    const container = document.getElementById('mm-cart-items');
    if (!container) return;

    container.addEventListener('click', (e) => {
      // Qty buttons
      const qtyBtn = e.target.closest('.mm-qty-btn');
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const qty = parseInt(qtyBtn.dataset.qty, 10);
        if (key) {
          debouncedUpdateByKey(key, qty);
        } else {
          const line = parseInt(qtyBtn.dataset.line, 10);
          debouncedUpdateQty(line, qty);
        }
        return;
      }

      // Remove button \u2014 utilise item.key (stable) plut\u00f4t que line (fragile)
      const removeBtn = e.target.closest('.mm-item-remove');
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        if (key) {
          removeByKey(key);
        } else {
          const line = parseInt(removeBtn.dataset.line, 10);
          updateQty(line, 0);
        }
        return;
      }
    });
  }

  function debouncedUpdateByKey(key, qty) {
    // Optimistic UI
    const items = document.querySelectorAll('.mm-cart-item');
    items.forEach(el => {
      if (el.querySelector(`[data-key="${key}"]`)) {
        const qtyEl = el.querySelector('.mm-qty-value');
        if (qtyEl && qty > 0) qtyEl.textContent = qty;
      }
    });
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(() => updateQtyByKey(key, qty), CONFIG.DEBOUNCE_DELAY);
  }

  async function updateQtyByKey(key, qty) {
    if (isUpdating) return;
    isUpdating = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      cart = await res.json();
      const realItems = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID);
      if (realItems.length === 0 && isAddonInCart()) {
        const addonItem = cart.items.find(i => i.variant_id === CONFIG.ADDON_VARIANT_ID);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: addonItem.key, quantity: 0 }),
        });
        cart = await fetchCart();
      }
      upsellProducts = await fetchUpsellProducts(cart.items);
      upsellIndex = 0;
      const realCount = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID).length;
      if (realCount === 0) { await renderEmpty(); } else { renderFilled(); }
      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: cart }));
    } catch (e) {
      console.error('[MM] updateQtyByKey error:', e);
      fetchAndRender();
    } finally {
      isUpdating = false;
    }
  }

  function debouncedUpdateQty(line, qty) {
    // Optimistic UI: mise \u00e0 jour visuelle imm\u00e9diate
    const qtyEl = document.querySelector(`.mm-cart-item[data-line="${line}"] .mm-qty-value`);
    if (qtyEl && qty > 0) qtyEl.textContent = qty;

    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(() => updateQty(line, qty), CONFIG.DEBOUNCE_DELAY);
  }

  async function removeByKey(key) {
    if (isUpdating) return;
    isUpdating = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      cart = await res.json();
      // Si plus que l'addon \u2192 le retirer aussi
      const realItems = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID);
      if (realItems.length === 0 && isAddonInCart()) {
        const addonItem = cart.items.find(i => i.variant_id === CONFIG.ADDON_VARIANT_ID);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: addonItem.key, quantity: 0 }),
        });
        cart = await fetchCart();
      }
      upsellProducts = await fetchUpsellProducts(cart.items);
      upsellIndex = 0;
      const realCount = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID).length;
      if (realCount === 0) { await renderEmpty(); } else { renderFilled(); }
      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: cart }));
    } catch (e) {
      console.error('[MM] removeByKey error:', e);
      fetchAndRender();
    } finally {
      isUpdating = false;
    }
  }

  async function updateQty(line, qty) {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty }),
      });
      cart = await res.json();

      // Si le panier ne contient plus que l'addon, le retirer aussi
      const realItems = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID);
      if (realItems.length === 0 && isAddonInCart()) {
        const addonItem = cart.items.find(i => i.variant_id === CONFIG.ADDON_VARIANT_ID);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: addonItem.key, quantity: 0 }),
        });
        cart = await fetchCart();
      }

      upsellProducts = await fetchUpsellProducts(cart.items);
      upsellIndex = 0;

      const realCount = cart.items.filter(i => i.variant_id !== CONFIG.ADDON_VARIANT_ID).length;
      if (realCount === 0) {
        await renderEmpty();
      } else {
        renderFilled();
      }

      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: cart }));
    } catch (e) {
      console.error('[MM] updateQty error:', e);
      fetchAndRender();
    } finally {
      isUpdating = false;
    }
  }

  // ============================================================
  // ADD TO CART
  // ============================================================
  async function addToCart(variantId, quantity = 1) {
    _mmFetchCount++;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!res.ok) throw new Error('Erreur ajout panier');
      return res.json();
    } finally {
      _mmFetchCount--;
    }
  }

  // ============================================================
  // INTERCEPT "Ajouter au panier" du th\u00e8me
  // Strat\u00e9gie multi-couche pour compatibilit\u00e9 Symmetry + autres th\u00e8mes
  // ============================================================
  function interceptAddToCart() {
    // \u2500\u2500 1. Monkey-patch fetch \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    // Intercepte TOUS les appels fetch vers /cart/add.js, y compris les AJAX
    // du th\u00e8me qui contournent le form submit. Le compteur _mmFetchCount
    // emp\u00eache nos propres appels internes de d\u00e9clencher openCart().
    const _origFetch = window.fetch;
    window.fetch = async function(input, init) {
      const url = typeof input === 'string' ? input
               : (input instanceof Request ? input.url : String(input || ''));
      const response = await _origFetch.call(this, input, init);
      if (url.includes('/cart/add') && _mmFetchCount === 0) {
        // Appel externe d\u00e9tect\u00e9 \u2192 ouvrir notre drawer apr\u00e8s un court d\u00e9lai
        setTimeout(openCart, 80);
      }
      return response;
    };

    // \u2500\u2500 2. Form submit en capture phase \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    // useCapture=true : s'ex\u00e9cute AVANT les listeners du th\u00e8me (theme.js)
    // stopImmediatePropagation : emp\u00eache le th\u00e8me de g\u00e9rer aussi le submit
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const formData = new FormData(form);
      _mmFetchCount++;
      try {
        await _origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.fromEntries(formData)),
        });
      } catch (_) {}
      _mmFetchCount--;

      openCart();
    }, { capture: true });

    // \u2500\u2500 3. Clic sur le lien panier en capture phase \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    // Emp\u00eache la navigation vers /cart et ouvre notre drawer \u00e0 la place
    // G\u00e8re aussi les URLs localis\u00e9es (ex: /fr/cart) et la classe .cart-link du th\u00e8me Symmetry
    document.addEventListener('click', (e) => {
      const el = e.target.closest('a');
      if (!el) return;
      const isCartLink = el.classList.contains('cart-link') ||
                         el.pathname === '/cart' ||
                         el.pathname === '/cart/' ||
                         /\/cart\/?$/.test(el.pathname);
      if (isCartLink) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openCart();
      }
    }, { capture: true });

    // \u2500\u2500 4. Events custom (compatibilit\u00e9 th\u00e8mes tiers) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
    document.addEventListener('cart:add', openCart);
    document.addEventListener('product:added-to-cart', openCart);
    document.addEventListener('theme:cart:added', openCart);
  }

  // ============================================================
  // HEADER CART COUNT
  // ============================================================
  function updateCartCount(count) {
    // D\u00e9duire l'addon du compteur affich\u00e9
    const addonQty = cart?.items
      ?.filter(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)
      .reduce((s, i) => s + i.quantity, 0) ?? 0;
    const displayCount = Math.max(0, count - addonQty);

    // S\u00e9lecteurs couvrant Symmetry + th\u00e8mes g\u00e9n\u00e9riques
    const counters = document.querySelectorAll(
      '.cart-link__count, [data-cart-count], .cart-count, .header__cart-count, .cart__count, .cart-item-count'
    );
    counters.forEach(el => {
      el.textContent = displayCount;
      el.style.display = displayCount > 0 ? '' : 'none';
    });
  }

  // Mise \u00e0 jour du compteur header \u00e0 chaque \u00e9v\u00e9nement cart
  document.addEventListener('mm:cart:updated', (e) => {
    updateCartCount(e.detail.item_count);
  });

  // Initialisation du compteur au chargement de la page
  async function initCartCount() {
    try {
      const c = await fetchCart();
      const addonQty = c.items
        .filter(i => i.variant_id === CONFIG.ADDON_VARIANT_ID)
        .reduce((s, i) => s + i.quantity, 0);
      const displayCount = Math.max(0, c.item_count - addonQty);
      const counters = document.querySelectorAll(
        '.cart-link__count, [data-cart-count], .cart-count, .header__cart-count, .cart__count, .cart-item-count'
      );
      counters.forEach(el => {
        el.textContent = displayCount;
        el.style.display = displayCount > 0 ? '' : 'none';
      });
    } catch (_) {}
  }

  // ============================================================
  // UTILS
  // ============================================================
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  function escHtml(str) {
    if (typeof str !== 'string') return str ?? '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    // Bouton fermer
    document.getElementById('mm-cart-close')?.addEventListener('click', closeCart);

    // Overlay click
    overlay()?.addEventListener('click', closeCart);

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeCart();
    });

    // Liens/boutons d'ouverture du panier (capture phase + stopImmediatePropagation
    // pour prendre la main avant les handlers bubble du th\u00e8me Symmetry)
    document.querySelectorAll('[data-cart-toggle], .cart-link, .header__cart').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        openCart();
      }, { capture: true });
    });

    // Intercepter les soumissions "Ajouter au panier"
    interceptAddToCart();

    // Initialiser le compteur panier header au chargement
    initCartCount();
  }

  // Exposer l'API publique
  window.MMCart = { open: openCart, close: closeCart, refresh: fetchAndRender };

  // D\u00e9marrage
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  
  }
})();

function initTrustSlider() {
  if (document.getElementById('mm-trust-style')) return;
  const st = document.createElement('style');
  st.id = 'mm-trust-style';
  st.textContent = [
    '.mm-drawer__header{justify-content:unset!important;gap:10px!important}',
    '.mm-header-sep{width:1px;height:14px;background:#ddd;flex-shrink:0}',
    '.mm-trust-slider{flex:1;position:relative;height:18px;overflow:hidden;min-width:0}',
    '.mm-trust-slide{position:absolute!important;width:100%;height:18px;display:flex;align-items:center;justify-content:center;gap:5px;font-size:10px;color:#777;opacity:0!important;transition:opacity .5s ease;white-space:nowrap}',
    '.mm-trust-slide--active{opacity:1!important}',
    '.mm-trust-slide strong{color:#111;font-weight:500}',
    '.mm-trust-dots{display:flex;gap:3px;align-items:center;flex-shrink:0}',
    '.mm-trust-dot{width:4px;height:4px;border-radius:50%;background:#ddd;transition:background .3s;display:block}',
    '.mm-trust-dot--active{background:#222!important}',
    '@media(max-width:768px){.mm-trust-dots{flex-direction:column}}'
  ].join('');
  document.head.appendChild(st);
  const slides = document.querySelectorAll('.mm-trust-slide');
  const dots   = document.querySelectorAll('.mm-trust-dot');
  if (!slides.length) return;
  let cur = 0;
  setInterval(function() {
    slides[cur].classList.remove('mm-trust-slide--active');
    dots[cur].classList.remove('mm-trust-dot--active');
    cur = (cur + 1) % slides.length;
    slides[cur].classList.add('mm-trust-slide--active');
    dots[cur].classList.add('mm-trust-dot--active');
  }, 2500);
}
document.addEventListener('DOMContentLoaded', initTrustSlider);


// ── BADGE FIX + TRACKING (Meta / Google / TikTok) ────────────────────────
(function() {
  var _fetch = window.fetch;
  window.fetch = function() {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var promise = _fetch.apply(this, arguments);

    if (/\/cart\/add/.test(url)) {
      promise.then(function(res) {
        return res.clone().json();
      }).then(function(data) {
        var items = data.items || (data.id ? [data] : []);
        var item = items[0] || {};
        var price = (item.price || 0) / 100;
        var qty   = item.quantity || 1;
        var name  = item.product_title || item.title || '';
        var vid   = String(item.variant_id || item.id || '');
        var value = +(price * qty).toFixed(2);

        // 1. Meta Pixel
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', {
            content_ids:  [vid],
            content_name: name,
            content_type: 'product',
            value:        value,
            currency:     'EUR',
            num_items:    qty
          });
        }

        // 2. Google / GTM — GA4 add_to_cart
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'EUR',
              value:    value,
              items: [{
                item_id:   vid,
                item_name: name,
                price:     price,
                quantity:  qty
              }]
            }
          });
        }

        // 3. TikTok Pixel
        if (typeof window.ttq !== 'undefined' && typeof window.ttq.track === 'function') {
          window.ttq.track('AddToCart', {
            content_id:   vid,
            content_name: name,
            content_type: 'product',
            value:        value,
            currency:     'EUR',
            quantity:     qty
          });
        }

        // 4. Badge mise à jour immédiate
        _fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var count = cart.item_count || 0;
          document.querySelectorAll(
            '.cart-link__count, .cart-count-bubble, [data-cart-count], .cart-count, .header__cart-count'
          ).forEach(function(el) { el.textContent = count > 0 ? count : ''; });
          document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: cart }));
        }).catch(function() {});

      }).catch(function() {});
    }

    return promise;
  };
})();
